import Badge from '../ui/Badge'

export default function TagList({ tags }) {
    if (!tags?.length) return null
    return (
        <div className="flex flex-wrap gap-1.5">
            {tags.map((t) => (
                <Badge key={t} tone="accent">{t}</Badge>
            ))}
        </div>
    )
}
